import React from 'react';
import clsx from 'clsx';
import IconLogo from '@/assets/icons/icon-logo.svg?react';

interface CanvasLoaderProps {
  className: string;
  onClick?: () => void;
  text?: string;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

export const CanvasLoader: React.FC<CanvasLoaderProps> = ({ className = '', onClick }) => {
  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <div
      onClick={handleClick}
      className={clsx('bg-neutral-10 relative h-[832px] w-[1200px] p-5', className)}
    >
      <div className="flex h-full w-full items-center justify-center outline-offset-[-1px] outline-indigo-500 outline-dashed">
        <div className="flex flex-col items-center justify-start gap-6">
          <div className="relative h-10 w-10">
            <div className="absolute top-0 left-0 h-10 w-10 overflow-hidden rounded-xl border border-neutral-100 shadow-sm">
              <div className="absolute top-1 left-1 h-7 w-7">
                <IconLogo className="h-7 w-7 text-neutral-900" />
              </div>
            </div>
          </div>
          <div className="inline-flex w-52 items-start justify-start gap-2 rounded-2xl p-2">
            <div className="relative flex h-1 flex-1 items-center justify-start overflow-hidden rounded-2xl bg-neutral-100">
              <div className={clsx('loader-thumb loader-once rounded-2xl bg-lime-400')} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const LoaderCanvas: React.FC<{ className?: string }> = ({ className = '' }) => {
  return (
    <div className={clsx('relative flex h-full w-full items-center justify-center', className)}>
      <CanvasLoader className="" />
    </div>
  );
};
